import { ConcreteEncodable } from "./ConcreteEncodable";

import { BulkOrderLifeCycleEventImplEncoder } from "../../encoder/BulkOrderLifeCycleEventImplEncoder";

import * as CubiqTS from "../../index";
import { BulkOrderLifeCycleEvent } from "../BulkOrderLifeCycleEvent";

export class BulkOrderLifeCycleEventImpl
  extends ConcreteEncodable
  implements BulkOrderLifeCycleEvent
{
  public static enType: string = "com.bcdfx.model.event.lifecycle.BulkOrderLifeCycleEventImpl";

  /*FID=1*/
  public errors: CubiqTS.Errors | null = null;
  /*FID=2*/
  public events: Array<CubiqTS.OrderLifeCycleEvent> | null = null;
  /*FID=3*/
  public eventTypeId: CubiqTS.FxLifeCycleEventType;
  /*FID=4*/
  public rejectType: CubiqTS.RejectSubType;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = BulkOrderLifeCycleEventImplEncoder.Instance;
    this.setEncodableType(BulkOrderLifeCycleEventImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "BulkOrderLifeCycleEventImpl[" +
      "errors=" +
      this.errors +
      "events=" +
      this.events +
      "eventTypeId=" +
      this.eventTypeId +
      "rejectType=" +
      this.rejectType +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
